export interface PumpCapacity {
  pumpCapacityId: number;
  pumpCapacityDesc?: string;
}
